import { useState, useEffect, Fragment } from 'react'
import { Typography, Radio, RadioGroup, FormControlLabel } from '@mui/material'
import {
  useServiceClassification,
  useCatalogsVendorListings,
} from 'utils/api/hooks'
import PopupRadioSelect from 'components/common/PopupRadioSelect'
import styled from '@emotion/styled'

const StyleFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  margin: 0,
  maxWidth: '100%',
  wordBreak: 'break-word',
  '& .MuiFormControlLabel-label': {
    ...theme.typography.paraBodyMedium,
    paddingLeft: '8px',
  },
}))

const ServiceClassificationSelectRadio = ({
  value,
  onChange,
  fullWidth,
  size,
  isLarge,
  isMobile,
}) => {
  // Fetching data
  const { data: catalogs } = useCatalogsVendorListings()
  const { data: currentClassification } = useServiceClassification(value)

  // State management
  const [selectedValue, setSelectedValue] = useState('')
  const [selectedName, setSelectedName] = useState('')

  // Effect to update selected name
  useEffect(() => {
    if (currentClassification?.name) {
      setSelectedName(currentClassification.name)
    } else {
      setSelectedName('')
    }
  }, [currentClassification?.name])

  useEffect(() => {
    setSelectedValue(value || '')
  }, [value])

  // Handle selection change
  const handleSelectionChange = (event) => {
    const selectedId = event.target.value
    const selectedName = event.target.name
    setSelectedValue(selectedId)
    if (isLarge && onChange) {
      onChange(selectedId, selectedName)
    }
  }

  // Handle click for unselecting
  const handleSelectionClick = (event) => {
    const selectedId = event.target.value
    if (selectedId === selectedValue) {
      if (isLarge && onChange) {
        onChange(null, null)
        setSelectedName('')
      }
      setSelectedValue('')
    }
  }

  const renderSubcatalogItems = (items) =>
    items?.map((item) => (
      <StyleFormControlLabel
        key={item.serviceClassification?._id}
        value={item.serviceClassification?._id}
        name={item.serviceClassification?.name}
        control={
          <Radio
            onClick={(e) => {
              handleSelectionClick(e)
            }}
            sx={{ padding: 0, margin: 0 }}
          />
        }
        label={item.serviceClassification?.name}
      />
    ))

  const renderSubcatalogs = (subcatalogs) =>
    subcatalogs?.map((subcatalog) => (
      <Fragment key={subcatalog._id}>
        {subcatalogs.length > 1 && (
          <Typography variant="paraBodyMedium">{subcatalog.name}</Typography>
        )}
        {renderSubcatalogItems(subcatalog?.items)}
      </Fragment>
    ))

  const renderCatalogs = () =>
    catalogs?.map((catalog) => (
      <Fragment key={catalog._id}>
        <Typography variant="paraTitleSmall">{catalog.name}</Typography>
        {renderSubcatalogs(catalog?.subcatalogs)}
      </Fragment>
    ))

  return (
    <PopupRadioSelect
      fullWidth={fullWidth}
      placeholder="服務"
      selectedText={selectedName}
      size={size}
      isLarge={isLarge}
      isMobile={isMobile}
      onChange={onChange}
      selectedId={selectedValue}
      modalContent={
        <RadioGroup
          value={selectedValue}
          onChange={handleSelectionChange}
          sx={{ gap: '20px' }}
        >
          {renderCatalogs()}
        </RadioGroup>
      }
    />
  )
}

export default ServiceClassificationSelectRadio
